const actions = {
  INIT_FAILED: 'BOTTOMLINE_INIT_FAILED',
  INIT_SUCCESS: 'BOTTOMLINE_INIT_SUCCESS',

  SEND_EVENT_FAILED: 'BOTTOMLINE_SEND_EVENT_FAILED',
  SEND_EVENT_SUCCESS: 'BOTTOMLINE_SEND_EVENT_SUCCESS',

  SEND_SCREENVIEW_FAILED: 'BOTTOMLINE_SEND_SCREENVIEW_FAILED',
  SEND_SCREENVIEW_SUCCESS: 'BOTTOMLINE_SEND_SCREENVIEW_SUCCESS',

  initFailed: (payload) => ({
    payload,
    type: actions.INIT_FAILED,
  }),
  initSuccess: () => ({
    type: actions.INIT_SUCCESS,
  }),

  sendEventFailed: (payload) => ({
    payload,
    type: actions.SEND_EVENT_FAILED,
  }),
  sendEventSuccess: (payload) => ({
    payload,
    type: actions.SEND_EVENT_SUCCESS,
  }),

  sendScreenviewFailed: (payload) => ({
    payload,
    type: actions.SEND_SCREENVIEW_FAILED,
  }),
  sendScreenviewSuccess: (payload) => ({
    payload,
    type: actions.SEND_SCREENVIEW_SUCCESS,
  }),
};

export default actions;
